﻿<script>
	export default {
		props: {
			href: String,
			target: String,
			hideLink: Boolean
		},
		render: function (createElement) {
			if (!this.href || this.hideLink) {
				// get only the first element
				// need to wrap it up in case of multi-root
				return this.$slots.default[0];
			}

			return createElement(
				'a', {
					attrs: {
						href: this.href,
						target: this.target
					},
					on: this.$listeners
				},
				this.$slots.default);
		}
	}
</script>